import React from 'react';
import { Logo } from '../../../shared/components';
import { styled } from '@material-ui/core';

const Header = styled('div')({
  display: 'none',

  '@media print': {
    display: 'block',
    position: 'relative',
    top: 0,
    zIndex: 9999,
    width: '100%',
  },
});

const PrintHeader = () => {
  return (
    <Header>
      <Logo size="small" />
    </Header>
  );
};

export default PrintHeader;
